// UI options for the AI / Models page (dropdowns only).
//
// MIRRORS cdk/src/stacks/llm/core/model-allowlist.ts. The CDK reader
// (getActiveModel → isAllowedModel) is the HARD enforcement — an unlisted model
// falls back and is never served — so this list is a convenience for the operator
// dropdown, not a security boundary. Keep it in sync with the allowlist.

export const AI_ROLES = ["heavy", "light", "embedding"] as const;
export const AI_ENGINES = ["native", "langgraph"] as const;

export interface ModelOption {
  provider: "bedrock" | "openai";
  modelId: string;
  label: string;
}

export const AI_MODEL_OPTIONS: ModelOption[] = [
  { provider: "bedrock", modelId: "us.meta.llama4-maverick-17b-instruct-v1:0", label: "Llama 4 Maverick (heavy default)" },
  { provider: "bedrock", modelId: "us.meta.llama4-scout-17b-instruct-v1:0", label: "Llama 4 Scout" },
  { provider: "bedrock", modelId: "us.amazon.nova-pro-v1:0", label: "Amazon Nova Pro" },
  { provider: "bedrock", modelId: "us.amazon.nova-lite-v1:0", label: "Amazon Nova Lite" },
  { provider: "bedrock", modelId: "us.deepseek.r1-v1:0", label: "DeepSeek-R1" },
  { provider: "openai", modelId: "gpt-5-nano", label: "OpenAI GPT-5 nano (light default)" },
  { provider: "openai", modelId: "gpt-5-mini", label: "OpenAI GPT-5 mini" },
  { provider: "openai", modelId: "gpt-4o-mini", label: "OpenAI GPT-4o mini (eval baseline)" },
];

export interface AiModelRow {
  role: string;
  provider: string;
  model_id: string;
  engine: string | null;
  params: Record<string, unknown>;
  active: boolean;
  version: number;
  notes: string | null;
  updated_at: string;
}

export interface AiInvocationRow {
  created_at: string;
  role: string | null;
  provider: string | null;
  model_id: string | null;
  engine: string | null;
  valid: boolean | null;
  latency_ms: number | null;
  est_cost_usd: number | null;
  error: string | null;
}
